import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";
import VideoCard from "@/components/base/VideoCard";

export default function FeaturedGrid() {
  return (
    <div className="bg-background-100">
      {categories.map((cat, index) => {
        const list = videos
          .filter((v) => v.category === cat.slug)
          .slice(0, 4);
        return (
          <section
            key={cat.slug}
            className="w-full px-4 md:px-8 py-10 md:py-14"
          >
            <div className="flex items-end justify-between mb-6 gap-3 flex-wrap">
              <div className="flex items-center gap-3">
                <span
                  className={`w-10 h-10 rounded-md flex items-center justify-center ${
                    index === 1
                      ? "bg-accent-500"
                      : index === 2
                      ? "bg-secondary-800"
                      : "bg-primary-500"
                  }`}
                >
                  <i className={`${cat.icon} text-background-50 text-xl`} />
                </span>
                <div>
                  <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950">
                    {cat.name}
                  </h2>
                  <p className="text-xs md:text-sm text-foreground-600 hidden sm:block">
                    {cat.description}
                  </p>
                </div>
              </div>
              <Link
                to={`/category/${cat.slug}`}
                className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600 whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {list.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}